export enum KnowledgeBaseSkeletonTypeEnum {
    UPPER_BANNER = 'UPPER_BANNER',
    LOWER_BANNER = 'LOWER_BANNER',
}
